import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { effects } from './emobility.ngrx-wrapper';

@NgModule({ imports: [EffectsModule.forFeature(effects)] })
export class EmobilitySharedModule {}
